import Vue from 'vue'
import Vuex from 'vuex'

import api from '@/api'

import af from './af'
import ap from './ap'
import st from './st'
import pk from './pk'

Vue.use(Vuex)

const state = {
  user: null,
  tokenRefresher: null,
  accessToken: localStorage.getItem('accessToken') || '',
  refreshToken: localStorage.getItem('refreshToken') || ''
}

const getters = {
  user: state => state.user,
  accessToken: state => state.accessToken,
  refreshToken: state => state.refreshToken
 }

const mutations = {
  setUser(state, user) {
    state.user = user
  },
  setAccessToken (state, accessToken) {
    state.accessToken = accessToken
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken)
    } else {
      localStorage.removeItem('accessToken')
    }
  },
  setRefreshToken (state, refreshToken) {
    state.refreshToken = refreshToken
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken)
    } else {
      localStorage.removeItem('refreshToken')
    }
  },
}

const actions = {

  async updateAccessToken ({ commit, getters, dispatch }) {
    if (getters.refreshToken) {
      const response = await api.requestRefreshToken(getters.refreshToken)
      if (response) {
        commit('setAccessToken', response.access_token)
        commit('setRefreshToken', response.refresh_token)
        setTimeout(function () {
          dispatch('updateAccessToken')
        }, 6000000)
      } else {
        dispatch('logout')
      }
    }
  },

  async login ({ commit }, payload) {
    const response = await api.requestAccessToken(payload)
    return new Promise((resolve, reject) => {
      if (response) {
        commit('setAccessToken', response.access_token)
        commit('setRefreshToken', response.refresh_token)
        resolve()
      } else {
        reject('Feil brukernavn eller passord')
      }
    })
  },

  async me ({ commit }) {
    const response = await api.me()
    return new Promise((resolve, reject) => {
      if (response) {
        commit('setUser', response)
        resolve ()
      } else {
        reject()
      }
    })
  },

  logout ({ commit }) {
    commit('setAccessToken', null)
    commit('setRefreshToken', null)
  }
}

const store = new Vuex.Store({
  modules: {
    af,
    ap,
    st,
    pk
  },
  state,
  getters,
  mutations,
  actions
})

store.dispatch('updateAccessToken')

export default store

